import { ConfigurationService } from '../services/configuration.service';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-highlight-solution',
    templateUrl: './highlight-solution.component.html',
    styleUrls: ['./highlight-solution.component.scss']
})
export class HighlightSolutionComponent {
    @Input() data: HighlightSolution;

    constructor(private config: ConfigurationService) { }

    limit(content): string {
        return this.config.limitString(content, 120);
    }
}

export class HighlightSolution {
    id: string;
    image: string;
    title: string;
    supplier: HighlightSolutionSupplier = new HighlightSolutionSupplier();
    excerpt: String;
}

export class HighlightSolutionSupplier {
    id: string;
    title: string;
}
